import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';

import {
  BaseComponent,
  BaseFormComponent,
  FormlyService,
  ProductService,
  StockForecasting,
  UtilityService,
} from 'tms-lib';
import { StockForecastingOptions } from 'tms-web-shared';

@Component({
  selector: 'app-product-stock-forecasting',
  templateUrl: './product-stock-forecasting.component.html',
  styleUrl: './product-stock-forecasting.component.scss',
})
export class ProductStockForecastingComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseFormComponent) form: BaseFormComponent;

  @Input() productId: string;

  fields: FormlyFieldConfig[];
  searchFields: FormlyFieldConfig[];
  model: StockForecastingOptions = {} as StockForecastingOptions;

  constructor(
    public productService: ProductService,
    private formlyService: FormlyService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.productId) {
      this.productId = this.route.snapshot.paramMap.get('id');
    }
    this.getFields();
  }

  getModel(model: StockForecastingOptions) {
    this.productService
      .getStockForecasting('', this.productId, model.monthsToAnalyse, true, 'Total Stock', false, 'Current')
      .subscribe((stockForecasting: StockForecasting[]) => {
        this.form.updateModel(stockForecasting[0]);
      });
  }

  private getFields() {
    this.searchFields = [
      this.formlyService.select(
        'monthsToAnalyse',
        $localize`Months to Analyse`,
        this.utilityService.mapToSelectOptions([1, 3, 6, 9, 12]),
      ),
    ];

    const last12Months = this.utilityService.getLast12Months('Current');
    this.fields = this.formlyService.threeColumnGrid(
      [
        this.formlyService.numberReadonly('callOffStock', $localize`Call Off Stock`),
        this.formlyService.textReadonly('callOffRequested', $localize`Call Off Requested`),
        this.formlyService.numberReadonly('stockQuantity', $localize`Stock Quantity`),
        this.formlyService.numberReadonly('qtyAllocated', $localize`Quantity Allocated`),
        this.formlyService.numberReadonly('qtyAllocatedPO', $localize`Quantity Allocated PO`),
        this.formlyService.numberReadonly('qtyUnAllocated', $localize`Unallocated Quantity`),
        this.formlyService.numberReadonly('outstandingPO', $localize`Outstanding Purchases`),
        this.formlyService.numberReadonly('callOffReady', $localize`Call Off Ready`),
        this.formlyService.numberReadonly('nettStock', $localize`Nett Stock`),
        this.formlyService.numberReadonly('nettOverLargestStockItem', $localize`Nett Usable`),
      ],
      [
        this.formlyService.numberReadonly('currentRequirement', last12Months[0]),
        this.formlyService.numberReadonly('requirementMonth1', last12Months[1]),
        this.formlyService.numberReadonly('requirementMonth2', last12Months[2]),
        this.formlyService.numberReadonly('requirementMonth3', last12Months[3]),
        this.formlyService.numberReadonly('requirementMonth4', last12Months[4]),
        this.formlyService.numberReadonly('requirementMonth5', last12Months[5]),
        this.formlyService.numberReadonly('requirementMonth6', last12Months[6]),
        this.formlyService.numberReadonly('requirementMonth7', last12Months[7]),
        this.formlyService.numberReadonly('requirementMonth8', last12Months[8]),
        this.formlyService.numberReadonly('requirementMonth9', last12Months[9]),
        this.formlyService.numberReadonly('requirementMonth10', last12Months[10]),
        this.formlyService.numberReadonly('requirementMonth11', last12Months[11]),
      ],
      [
        this.formlyService.numberReadonly('averageSales', $localize`Average Sales`),
        this.formlyService.numberReadonly('monthsStock', $localize`Months Stock`),
        this.formlyService.numberReadonly('minimumStock', $localize`Minimum Stock`),
        this.formlyService.numberReadonly('minimumOrderQty', $localize`Minimum Order Quantity`),
        this.formlyService.numberReadonly('minimumStockItemQuantity', $localize`Minimum Stock Item Quantity`),
        this.formlyService.numberReadonly('largestStockItem', $localize`Largest Stock Item`),
        this.formlyService.numberReadonly('leadTime', $localize`Lead Time`),
        this.formlyService.numberReadonly('recommendation', $localize`Recommendation`),
      ],
    );
  }
}
